import React,{useState,useContext} from 'react';
// useEffect,
import ReactTooltip from 'react-tooltip';
import {  Button } from 'react-bootstrap';
// ListGroup, Container, Row, Col, Modal,, Nav
import { withRouter } from "react-router-dom";
// Link,
import { apiUrl, myHeaders_Auth_With_Cache_Control, user_Status } from "Api/Api";
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

// import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';

import { get_current_unix_stamp } from "utils/Helper"

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

//import './style.css';


function FollowButton (props) {
  const user_context = useContext(UserContext);

  const button_info_map = {
    'followed': {
      button_text: 'Following',
      button_tooltip: 'Click to Unfollow',
      button_variant: 'secondary',
      button_icon: <i className="fa fa-check"/>
    },
    'unfollowed': {
      button_text: 'Follow',
      button_tooltip: user_Status ? 'Click to Follow' : 'Login to Follow',
      button_variant: 'pkprimary',
      button_icon: <i className="fa fa-plus"/>
    }
  };
  
  const [followed,setFollowed] = useState(props.followed);
  const [button_info,setButtonInfo] = useState(props.followed ? button_info_map['followed'] : button_info_map['unfollowed']);

  //console.log("FollowButton",props);


  /*
  useEffect(() => {
    console.log("FollowButton useEffect",props);
  });
  */

  async function followUnfollow () {
    console.log("followUnfollow",followed,props.entity_info);
    
    if (!user_context.user_info.entity_uuid) {
      window.localStorage.setItem('loginOrigin',props.location.pathname);
      props.history.push('/login');
      return;
    }
    
    let favorited_time;
    if (followed) {
      favorited_time = -1; // for unfollow
      setButtonInfo(button_info_map.unfollowed);
    } else {
      favorited_time = get_current_unix_stamp();
      setButtonInfo(button_info_map.followed);
    }
    
    setFollowed(!followed);
    
    let patch_obj = {
      [props.entity_info.entity_type+'.audience']: [
        {
          entity_uuid: props.entity_info.entity_uuid,
          xref_data: {
            favorited_time
          }
        }
      ]
    };
    
    await axios.patch(`${apiUrl}users/${user_context.user_info.entity_uuid}`,patch_obj);
    
    // are we friends now? let's check
    let friends_results = await axios.get(`${apiUrl}users/${user_context.user_info.entity_uuid}/users.audience/${props.entity_info.entity_uuid}`, myHeaders_Auth_With_Cache_Control);
    if (friends_results.data.friended_time) {
      // yes we are friends!
      if (props.friendsOrNot) {
        props.friendsOrNot(true);
      }
    } else {
      if (props.friendsOrNot) {
        props.friendsOrNot(false);
      }
    }
  }

  return (
    <React.Fragment>
      <Button
        variant={button_info.button_variant}
        data-place='top'
        data-tip={button_info.button_tooltip}
        onClick={followUnfollow}
      >
        {button_info.button_icon} {button_info.button_text}
        <ReactTooltip />
      </Button>
    </React.Fragment>
  );
}

export default withRouter(FollowButton);